webpackJsonp([35],{

/***/ 202:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/Logo_sdg1.c1da66f.svg";

/***/ }),

/***/ 253:
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiPz4KPHN2ZyB3aWR0aD0iMjJweCIgaGVpZ2h0PSIyMnB4IiB2aWV3Qm94PSIwIDAgMjIgMjIiIHZlcnNpb249IjEuMSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayI+CiAgICA8IS0tIEdlbmVyYXRvcjogU2tldGNoIDU3LjEgKDgzMDg4KSAtIGh0dHBzOi8vc2tldGNoLmNvbSAtLT4KICAgIDx0aXRsZT5QYXNzd29yZF8wPC90aXRsZT4KICAgIDxkZXNjPkNyZWF0ZWQgd2l0aCBTa2V0Y2guPC9kZXNjPgogICAgPGcgaWQ9IlBhc3N3b3JkXzAiIHN0cm9rZT0ibm9uZSIgc3Ryb2tlLXdpZHRoPSIxIiBmaWxsPSJub25lIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiPgogICAgICAgIDxnIGlkPSJJY19leWUxIiBmaWxsPSIjNUM2MTY4Ij4KICAgICAgICAgICAgPGcgaWQ9IkV5ZSIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMC45NTQ1NDUsIDQuNTAwMDAwKSI+CiAgICAgICAgICAgICAgICA8cGF0aCBkPSJNOS41NDU0NTQ1NSwwIEMzLjI4MjY4MTgyLDAgMCw0LjgzMiAwLDUuNiBDMCw2LjM2NiAzLjI4MjY4MTgyLDExLjIgOS41NDU0NTQ1NSwxMS4yIEMxNS44MDcyNzI3LDExLjIgMTkuMDkwOTA5MSw2LjM2NiAxOS4wOTA5MDkxLDUuNiBDMTkuMDkwOTA5MSw0LjgzMiAxNS44MDcyNzI3LDAgOS41NDU0NTQ1NSwwIEw5LjU0NTQ1NDU1LDAgWiBNOS41NDU0NTQ1NSw5LjkwNyBDNy4yMDIwNDU0NSw5LjkwNyA1LjMwMjUsNy45NzkgNS4zMDI1LDUuNiBDNS4zMDI1LDMuMjIxIDcuMjAyMDQ1NDUsMS4yOTEgOS41NDU0NTQ1NSwxLjI5MSBDMTEuODg4ODYzNiwxLjI5MSAxMy43ODc0NTQ1LDMuMjIxIDEzLjc4NzQ1NDUsNS42IEMxMy43ODc0NTQ1LDcuOTc5IDExLjg4ODg2MzYsOS45MDcgOS41NDU0NTQ1NSw5LjkwNyBMOS41NDU0NTQ1NSw5LjkwNyBaIE05LjU0NTQ1NDU1LDUuNiBDOS4xNTY5NTQ1NSw1LjE1MyAxMC4xNzgzMTgyLDMuNDQ2IDkuNTQ1NDU0NTUsMy40NDYgQzguMzczMjcyNzMsMy40NDYgNy40MjM1LDQuNDExIDcuNDIzNSw1LjYgQzcuNDIzNSw2Ljc4OSA4LjM3MzI3MjczLDcuNzU0IDkuNTQ1NDU0NTUsNy43NTQgQzEwLjcxNjY4MTgsNy43NTQgMTEuNjY3NDA5MSw2Ljc4OSAxMS42Njc0MDkxLDUuNiBDMTEuNjY3NDA5MSw1LjA1MyA5Ljg3NTcyNzI3LDUuOTc5IDkuNTQ1NDU0NTUsNS42IEw5LjU0NTQ1NDU1LDUuNiBaIiBpZD0iU2hhcGUiPjwvcGF0aD4KICAgICAgICAgICAgPC9nPgogICAgICAgIDwvZz4KICAgIDwvZz4KPC9zdmc+"

/***/ }),

/***/ 254:
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),

/***/ 319:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_Content__ = __webpack_require__(72);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixins_Utility__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mixins_GoogleAnalytics__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__main__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuex__ = __webpack_require__(6);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["a"] = ({
  name: "LoginForm",
  data: function data() {
    return {
      width: "30%",
      userEmail: undefined,
      password: undefined,
      iconEyeOpenPath: __webpack_require__(253),
      iconEyeClosePath: __webpack_require__(254),
      showLoading: false,
      formError: null,
      //
      userEmailError: "",
      passwordError: "",
      //
      showLoginForm: true,
      social: {},
      mode: null,
      ageCheck: false,
      emailPopup: false
    };
  },

  props: ["closePopupCB", "previousActionData"],
  components: {
    Popup: function Popup() {
      return new Promise(function(resolve) { resolve(); }).then(__webpack_require__.bind(null, 70));
    },
    Loading: function Loading() {
      return new Promise(function(resolve) { resolve(); }).then(__webpack_require__.bind(null, 170));
    },
    FormError: function FormError() {
      return __webpack_require__.e/* import() */(21/* duplicate */).then(__webpack_require__.bind(null, 188));
    }
  },
  created: function created() {
    var _this = this;

    __WEBPACK_IMPORTED_MODULE_4__main__["EventBus"].$on("getFBEmail", function () {
      _this.emailPopup = true;
      _this.userEmail = null;
      _this.width = "35%";
      _this.showLoginForm = false;
    });
    // signupError
    __WEBPACK_IMPORTED_MODULE_4__main__["EventBus"].$on("loginError", function (error) {
      var GA = {
        "Event Label": "Failure",
        Status: "FAILURE",
        ErrorCode: error.Code,
        ErrorMessage: error.Message
      };
      _this.loginEvent(GA);
      if (_this.mode) {
        var _GA = {
          "Event Label": "Failure",
          Status: "FAILURE",
          ErrorCode: error.Code,
          ErrorMessage: error.Message,
          Mode: _this.mode
        };
        _this.signUpEvent(_GA);
      }
      console.log("loginError", error);
      //
      _this.formError = error.Message;
      _this.$refs.loginBtnSubmit.disabled = false;
      _this.$refs.signupBtn.disabled = false;
      _this.showLoading = false;
      // To re-enable:
      document.getElementById("googlelogin").style.pointerEvents = "auto";
    });
    //signupSuccess
    __WEBPACK_IMPORTED_MODULE_4__main__["EventBus"].$on("loginSuccess", function () {
      var GA = {
        "Event Label": "Success",
        Status: "SUCCESS"
      };
      _this.loginEvent(GA);
      if (_this.mode) {
        var _GA2 = {
          "Event Label": "Success",
          Status: "SUCCESS",
          Mode: _this.mode
        };
        _this.signUpEvent(_GA2);
      }
      //
      // console.log("loginSuccess-previousActionData", this.previousActionData);
      if (_this.previousActionData) {
        if (_this.previousActionData.button && _this.previousActionData.button === "LIKEDISLIKE") {
          _this.updateLikeDislikeToFire(_this.previousActionData.content, _this.previousActionData.action);
        } else {
          switch (_this.previousActionData.popup) {
            case "PaymentPopup":
              _this.actListTicket().then(function (response) {
                var showPaymentPopup = true;
                if (response.length > 0) {
                  var index = response.findIndex(function (ele) {
                    return ele.contentid === _this.previousActionData.contentid;
                  });
                  if (index > -1) {
                    showPaymentPopup = false;
                  }
                }
                if (showPaymentPopup) {
                  var data = {
                    contentid: _this.previousActionData.contentid
                  };
                  if (_this.previousActionData.coupon) {
                    data.coupon = _this.previousActionData.coupon;
                  }
                  __WEBPACK_IMPORTED_MODULE_4__main__["EventBus"].$emit("PaymentPopup", data);
                }
              });
              break;
            case "sharedPopup":
              if (_this.previousActionData.action && _this.previousActionData.content) {
                _this.updateLikeDislikeToFire(_this.previousActionData.content, _this.previousActionData.action);
              }
              __WEBPACK_IMPORTED_MODULE_4__main__["EventBus"].$emit("sharedPopup", _this.previousActionData.content ? _this.previousActionData.content.contentid : _this.previousActionData.contentid);
              break;
            case "ContactPopup":
              __WEBPACK_IMPORTED_MODULE_4__main__["EventBus"].$emit("ContactPopup");
          }
        }
      }
      // Hide the popup
      _this.closePopupCB();
    });
  },

  watch: {
    formError: function formError(value) {
      var _this2 = this;

      if (value) {
        setTimeout(function () {
          _this2.formError = null;
        }, 5000);
      }
    },
    userEmail: function userEmail() {
      if (this.userEmailError) {
        this.userEmailError = "";
        document.getElementById("userEmail").classList.remove("formError");
      }
    },
    password: function password() {
      if (this.passwordError) {
        this.passwordError = "";
        document.getElementById("password").classList.remove("formError");
      }
    }
  },
  beforeDestroy: function beforeDestroy() {
    // Stop listening
    __WEBPACK_IMPORTED_MODULE_4__main__["EventBus"].$off("loginSuccess");
    __WEBPACK_IMPORTED_MODULE_4__main__["EventBus"].$off("loginError");
  },
  mounted: function mounted() {
    this.initGoogleSignupAPI();
  },

  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_5_vuex__["b" /* mapActions */])(["actListTicket", "actGetSubscriber"]), {
    check18plus: function check18plus(status) {
      var _this3 = this;

      this.width = "30%";
      if (status) {
        this.showLoading = true;
        if (!this.checkCookie()) {
          __WEBPACK_IMPORTED_MODULE_4__main__["EventBus"].$emit("loginUser", this.social, "L");
        } else {
          window.location.reload();
        }
      } else {
        this.showLoading = false;
        this.social = null;
        this.mode = null;
        this.emailPopup = false;
      }
      this.showLoginForm = true;
      setTimeout(function () {
        _this3.initGoogleSignupAPI();
      }, 100);
    },
    proceedClick: function proceedClick() {
      var _this4 = this;

      var showLogin = false;
      if (this.validateEmailInput()) {
        if (this.ageCheck) {
          this.showLoading = true;
          if (!this.checkCookie()) {
            showLogin = true;
            this.social.email = this.userEmail;
            __WEBPACK_IMPORTED_MODULE_4__main__["EventBus"].$emit("loginUser", this.social, "L");
          } else {
            window.location.reload();
          }
        } else {
          this.formError = "Please confirm your 18+";
        }
      }
      if (showLogin) {
        this.width = "30%";
        this.showLoginForm = true;
        setTimeout(function () {
          _this4.initGoogleSignupAPI();
          _this4.userEmail = null;
          _this4.emailPopup = false;
        }, 100);
      }
    },
    initGoogleSignupAPI: function initGoogleSignupAPI() {
      var _this5 = this;

      gapi.load("auth2", function () {
        var auth2 = gapi.auth2.init({
          client_id: "42494403169-nl3r32rr52d6bsrgvckmqe5vs4hp5o8n.apps.googleusercontent.com",
          cookiepolicy: "single_host_origin",
          scope: "profile"
        });

        auth2.attachClickHandler(document.getElementById("googlelogin"), {}, function (user) {
          var profile = user.getBasicProfile();
          if (profile.getId()) {
            var token = user.getAuthResponse().id_token;
            _this5.social = {
              app: "GOOGLE",
              token: token
            };
            _this5.mode = "GOOGLE";
            _this5.showLoader();
            _this5.actGetSubscriber({ email: profile.getEmail() }).then(function (response) {
              _this5.showLoader = false;
              if (response.error) {
                _this5.emailPopup = false;
                _this5.width = "25%";
                _this5.showLoginForm = false;
                //
                _this5.mode = "GOOGLE";
              } else {
                _this5.showLoading = true;
                if (!_this5.checkCookie()) {
                  __WEBPACK_IMPORTED_MODULE_4__main__["EventBus"].$emit("loginUser", _this5.social, "L");
                } else {
                  window.location.reload();
                }
              }
            }).catch(function (error) {
              _this5.emailPopup = false;
              _this5.width = "25%";
              _this5.showLoginForm = false;
              //
              _this5.mode = "GOOGLE";
            });

            //
            // EventBus.$emit('loginUser',this.social,'L');
          }
        }, function (error) {});
      });
    },
    signupFacebookCB: function signupFacebookCB() {
      if (this.showLoading) return;
      var self = this;
      // Get the login status
      // FB.getLoginStatus(response => {
      //   console.log('getLoginStatus',response);
      FB.login(function (response) {
        // console.log("fbrsponse", response);
        if (response.authResponse) {
          console.log('auth token', response.authResponse);
          // let GA = {
          //   "Event Label": "Success",
          //   Status: "SUCCESS"
          // };
          // self.facebookLoginEvent(GA);
          //
          var token = response.authResponse.accessToken;
          var userId = response.authResponse.userID;

          self.social = {
            app: "FB",
            token: token
          };
          // self.mode = "FACEBOOK";
          // self.showLoading = true;
          // EventBus.$emit("loginUser", self.social, "L");
          FB.api("/me", { fields: "id,name,email" }, function (response) {
            if (response) {
              var res = response;
              console.log('response result', res);
              var email = res.email;
              var param = {
                email: email
              };
              console.log('params', param);
              self.actGetSubscriber(param).then(function (response) {
                console.log('get subscriber response', response);
                if (response.error) {
                  self.width = "25%";
                  self.showLoginForm = false;
                  //
                  self.mode = "FACEBOOK";
                } else {
                  if (response.email) {
                    console.log('response email', response.email);
                    self.showLoader();
                    if (!self.checkCookie()) {
                      __WEBPACK_IMPORTED_MODULE_4__main__["EventBus"].$emit("loginUser", self.social, "L");
                    } else {
                      window.location.reload();
                    }
                  } else {
                    self.emailPopup = true;
                    self.width = "25%";
                    self.showLoginForm = false;
                    //
                    self.mode = "FACEBOOK";
                  }
                }
              }).catch(function (error) {
                self.emailPopup = false;
                self.width = "25%";
                self.showLoginForm = false;
                //
                self.mode = "FACEBOOK";
              });
            }
          });
        } else {
          // let GA = {
          //   "Event Label": "Failure",
          //   Status: "FAILURE",
          //   Response: JSON.stringify(response)
          // };
          // self.facebookLoginEvent(GA);
        }
      }, { scope: 'public_profile,email' });
      // });
    },
    showResetPasswordPopup: function showResetPasswordPopup(state) {
      __WEBPACK_IMPORTED_MODULE_4__main__["EventBus"].$emit("ResetPasswordPopup", state);
    },
    openSignUpPopup: function openSignUpPopup() {
      // Hide the popup
      this.closePopupCB();
      // open Login Popup
      __WEBPACK_IMPORTED_MODULE_4__main__["EventBus"].$emit("SignPopup", this.previousActionData);
    },
    closePopup: function closePopup() {
      // Hide the popup
      this.closePopupCB();
    },
    showLoader: function showLoader() {
      this.showLoading = true;
      this.$refs.loginBtnSubmit.disabled = true;
      this.$refs.signupBtn.disabled = true;
    },
    loginUserCB: function loginUserCB() {
      if (!this.isFormValid()) return;
      // To disable:
      document.getElementById("googlelogin").style.pointerEvents = "none";
      //
      this.showLoader();
      //
      if (!this.checkCookie()) {
        __WEBPACK_IMPORTED_MODULE_4__main__["EventBus"].$emit("loginUser", {
          email: this.userEmail,
          password: this.password,
          app: "SELF"
        }, "L");
      } else {
        window.location.reload();
      }
    },
    isFormValid: function isFormValid() {
      return this.validateEmailInput() && this.validatePassword();
    },
    validateEmailInput: function validateEmailInput() {
      var maxChar = 128;
      // validateEmail method was defined in Utility mixin
      if (!this.userEmail) {
        this.userEmailError = "Please enter E-mail";
        document.getElementById("userEmail").classList.add("formError");
        return false;
      } else if (!this.validateEmail(this.userEmail)) {
        this.userEmailError = "Invalid Email Id.Please enter in format xxx@yyy.com";
        document.getElementById("userEmail").classList.add("formError");
        return false;
      } else if (this.userEmail.length > maxChar) {
        this.userEmailError = "E-mail must be less than " + maxChar + " characters";
        document.getElementById("userEmail").classList.add("formError");
        return false;
      } else {
        this.userEmailError = "";
        document.getElementById("userEmail").classList.remove("formError");
        return true;
      }
    },
    validatePassword: function validatePassword() {
      var minChar = 8;
      var maxChar = 16;

      if (!this.password) {
        this.passwordError = "Please enter Password";
        document.getElementById("password").classList.add("formError");
        return false;
      } else if (this.password.length < minChar || this.password.length > maxChar) {
        this.passwordError = "Password should be " + minChar + " - " + maxChar + " characters long";
        document.getElementById("password").classList.add("formError");
        return false;
      }
      // else if (this.password.length > maxChar) {
      //   this.passwordError = `Password must be less than ${maxChar} characters`;
      //   document.getElementById("password").classList.add("formError");
      //   return false;
      // }
      // else if (!this.validateInputPassword(this.password)) {
      //   this.passwordError = `Password should contain atleast One special charcter, One upper case and One number.`;
      //   document.getElementById('password').classList.add('formError');
      //   return false;
      // }
      else {
          this.passwordError = "";
          document.getElementById("password").classList.remove("formError");
          return true;
        }
    },
    toggleInputMode: function toggleInputMode(_event) {
      // Get the target element
      var target = _event.target;
      // Get the container div of the input field
      var parentNode = target.parentNode.parentNode;
      // Get the input element from it
      var inputElm = parentNode.getElementsByTagName("input")[0];
      // Now change the type to text if password or vice-versa and change the icon
      if (inputElm.type === "password") {
        inputElm.type = "text";
        // Change the icon
        target.src = this.iconEyeClosePath;
      } else {
        inputElm.type = "password";
        // Change the icon
        target.src = this.iconEyeOpenPath;
      }
    }
  }),
  mixins: [__WEBPACK_IMPORTED_MODULE_1__mixins_Content__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__mixins_Utility__["a" /* default */], __WEBPACK_IMPORTED_MODULE_3__mixins_GoogleAnalytics__["a" /* default */]]
});

/***/ }),

/***/ 374:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Login_vue__ = __webpack_require__(319);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_63944a92_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Login_vue__ = __webpack_require__(377);
function injectStyle (ssrContext) {
  __webpack_require__(375)
}
var normalizeComponent = __webpack_require__(8)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-63944a92"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Login_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_63944a92_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Login_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ 375:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(376);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(169)("d686641e", content, true, {});

/***/ }),

/***/ 376:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(168)(true);
// imports


// module
exports.push([module.i, "input[data-v-63944a92]::-ms-clear,input[data-v-63944a92]::-ms-reveal{display:none}input[data-v-63944a92]:invalid{outline:none}input[type=email][data-v-63944a92],input[type=password][data-v-63944a92],input[type=search][data-v-63944a92],input[type=text][data-v-63944a92],textarea[data-v-63944a92]{font-size:18px;font-weight:400}input[data-v-63944a92]{caret-color:#4558dd;width:2px}.session-exp-popup[data-v-63944a92]{padding:20px}.login-logo[data-v-63944a92]{text-align:center}.login-logo img[data-v-63944a92]{width:25%;margin:5% 0}.vlt-signup-divd p[data-v-63944a92]{display:block;margin:15px 0;color:#212121;font-weight:550;font-size:15px;text-align:center;font-family:ProximanovaBold}.vlt-signup-divd .orline[data-v-63944a92]{border-bottom:1px solid #dcdcdc;margin-top:5%}.social-logo[data-v-63944a92]{margin:0 10%;display:-webkit-box;display:-ms-flexbox;display:flex}.social-logo div[data-v-63944a92]{-webkit-box-flex:1;-ms-flex:1;flex:1}.social-logo div div[data-v-63944a92]{cursor:pointer}.social-logo div div img[data-v-63944a92]{margin:10px;width:15%;float:left}.social-logo div div p[data-v-63944a92]{float:left;font-family:ProximanovaBold;margin-left:5px}.social-fb div[data-v-63944a92]{background:#3b5998;border-radius:2px}.social-fb div p[data-v-63944a92]{color:#fff;font-size:18px;margin-top:10px}.social-google div[data-v-63944a92]{border:2px solid #efecec;border-radius:2px;background:#efecec}.social-google div p[data-v-63944a92]{color:#000;font-size:18px;margin-top:8px}.login-form[data-v-63944a92]{margin:0 10%}.vlt-input-group[data-v-63944a92]{margin:0 0 10px}.vlt-lgn-fgtpwd[data-v-63944a92]{color:#212121;font-family:ProximanovaBold;margin-bottom:15px}.vlt-lgn-fgtpwd[data-v-63944a92]:hover{text-decoration:underline}.vlt-signup[data-v-63944a92]{padding:20px}.vlt-signup[data-v-63944a92] :first-child{margin-left:15%}.vlt-signup[data-v-63944a92] :nth-child(2){margin-left:10px;cursor:pointer;font-weight:600}.vlt-signup p[data-v-63944a92]{color:#212121;float:left}.login-header[data-v-63944a92]{color:#212121;font-family:ProximanovaBold;font-size:30px}.login-with[data-v-63944a92]{color:#212121;font-family:ProximanovaBold;font-size:14px;text-align:justify;margin:2% 0}.or[data-v-63944a92]{color:#212121;font-family:ProximanovaRegular;font-size:16px;font-weight:500;line-height:19px;text-align:justify}.login-label[data-v-63944a92]{color:#212121;font-family:ProximanovaBold;font-size:16px;line-height:20px}.login-error-message[data-v-63944a92]{color:#d0021b;font-family:ProximanovaRegular;font-size:16px;font-weight:100;line-height:18px;margin-top:5px}.new-user[data-v-63944a92]{color:#212121;font-family:ProximanovaRegular;font-size:16px;line-height:18px}.signup[data-v-63944a92]{color:#4558dd!important;font-family:ProximanovaBold;font-size:16px;line-height:18px;font-weight:700;border:none;background:transparent}.signup[data-v-63944a92]:hover{text-decoration:underline}.check-container[data-v-63944a92]{margin:5%}.check-container p[data-v-63944a92]:first-child{text-align:center;font-size:15px;margin-bottom:10px;color:#212121;font-family:ProximanovaSemibold}.check-container button[data-v-63944a92]:first-child{margin-bottom:20px}.check-container button.no[data-v-63944a92]{color:#212121!important;background:#fff!important;border:1px solid #212121!important}.check-container button.no[data-v-63944a92]:hover{background:#212121!important;color:#fff!important}.agecheck[data-v-63944a92]{color:#212121;font-family:ProximanovaSemibold;font-size:18px;line-height:30px}@media only screen and (max-width:600px){.session-exp-popup[data-v-63944a92]{padding:10px}.vlt-input-group[data-v-63944a92]{margin:0 0 5px}.vlt-input-group label[data-v-63944a92]{font-size:14px}.login-header[data-v-63944a92]{font-size:20px}.vlt-signup-divd p[data-v-63944a92]{margin:7px 0;font-size:16px}input[type=email][data-v-63944a92],input[type=password][data-v-63944a92],input[type=text][data-v-63944a92]{height:30px}.vlt-lgn-fgtpwd[data-v-63944a92]{margin-bottom:8px;font-size:12px}button[data-v-63944a92]{padding:8px;font-size:15px}.vlt-signup[data-v-63944a92]{padding:10px;text-align:center}.vlt-signup[data-v-63944a92] :first-child,.vlt-signup[data-v-63944a92] :nth-child(2){margin-left:0}.vlt-signup p[data-v-63944a92]{display:inline;text-align:center;float:none}.social-fb div p[data-v-63944a92],.social-google div p[data-v-63944a92]{font-size:14px}}", "", {"version":3,"sources":["/home/mobiotics/Projects/vpremiere/src/components/Popups/Login.vue"],"names":[],"mappings":"AACA,qEAAqE,YAAY,CAChF,AACD,+BAA+B,YAAY,CAC1C,AACD,yKAAiL,eAAe,eAAe,CAC9M,AACD,uBAAuB,oBAAoB,SAAS,CACnD,AACD,oCAAoC,YAAY,CAC/C,AACD,6BAA6B,iBAAiB,CAC7C,AACD,iCAAiC,UAAU,WAAW,CACrD,AACD,oCAAoC,cAAc,cAAc,cAAc,gBAAgB,eAAe,kBAAkB,2BAA6B,CAC3J,AACD,0CAA0C,gCAAgC,aAAa,CACtF,AACD,8BAA8B,aAAmB,oBAAoB,oBAAoB,YAAY,CACpG,AACD,kCAAkC,mBAAmB,WAAW,MAAM,CACrE,AACD,sCAAsC,cAAc,CACnD,AACD,0CAA0C,YAAY,UAAU,UAAU,CACzE,AACD,wCAAwC,WAAW,4BAA8B,eAAe,CAC/F,AACD,gCAAgC,mBAAmB,iBAAiB,CACnE,AACD,kCAAkC,WAAc,eAAe,eAAe,CAC7E,AACD,oCAAoC,yBAAyB,kBAAkB,kBAAkB,CAChG,AACD,sCAAsC,WAAc,eAAe,cAAc,CAChF,AACD,6BAA6B,YAAkB,CAC9C,AACD,kCAAkC,eAAiB,CAClD,AACD,iCAAiC,cAAc,4BAA8B,kBAAkB,CAC9F,AACD,uCAAuC,yBAAyB,CAC/D,AACD,6BAA6B,YAAY,CACxC,AACD,0CAA2C,eAAe,CACzD,AACD,2CAA2C,iBAAiB,eAAe,eAAe,CACzF,AACD,+BAA+B,cAAc,UAAU,CACtD,AACD,+BAA+B,cAAc,4BAA8B,cAAc,CACxF,AACD,6BAA6B,cAAc,4BAA8B,eAAe,mBAAmB,WAAW,CACrH,AACD,qBAAqB,cAAc,+BAAiC,eAAe,gBAAgB,iBAAiB,kBAAkB,CACrI,AACD,8BAA8B,cAAc,4BAA8B,eAAe,gBAAgB,CACxG,AACD,sCAAsC,cAAc,+BAAiC,eAAe,gBAAgB,iBAAiB,cAAc,CAClJ,AACD,2BAA2B,cAAc,+BAAiC,eAAe,gBAAgB,CACxG,AACD,yBAAyB,wBAAyB,4BAA8B,eAAe,iBAAiB,gBAAiB,YAAY,sBAAsB,CAClK,AACD,+BAA+B,yBAAyB,CACvD,AACD,kCAAkC,SAAS,CAC1C,AACD,gDAAgD,kBAAkB,eAAe,mBAAmB,cAAc,+BAAiC,CAClJ,AACD,qDAAsD,kBAAkB,CACvE,AACD,4CAA4C,wBAAyB,0BAA8B,kCAAmC,CACrI,AACD,kDAAkD,6BAA8B,oBAAwB,CACvG,AACD,2BAA2B,cAAc,gCAAkC,eAAe,gBAAgB,CACzG,AACD,yCACA,oCAAoC,YAAY,CAC/C,AACD,kCAAkC,cAAgB,CACjD,AACD,wCAAwC,cAAc,CACrD,AACD,+BAA+B,cAAc,CAC5C,AACD,oCAAoC,aAAa,cAAc,CAC9D,AACD,2GAAiH,WAAW,CAC3H,AACD,iCAAiC,kBAAkB,cAAc,CAChE,AACD,wBAAwB,YAAY,cAAc,CACjD,AACD,6BAA6B,aAAa,iBAAiB,CAC1D,AAGD,qFAA2C,aAAc,CACxD,AACD,+BAA+B,eAAe,kBAAkB,UAAU,CACzE,AAGD,wEAAsC,cAAc,CACnD,CACA","file":"Login.vue","sourcesContent":["\ninput[data-v-63944a92]::-ms-clear,input[data-v-63944a92]::-ms-reveal{display:none\n}\ninput[data-v-63944a92]:invalid{outline:none\n}\ninput[type=\"text\"][data-v-63944a92],input[type=\"search\"][data-v-63944a92],input[type=\"password\"][data-v-63944a92],input[type=\"email\"][data-v-63944a92],textarea[data-v-63944a92]{font-size:18px;font-weight:400\n}\ninput[data-v-63944a92]{caret-color:#4558dd;width:2px\n}\n.session-exp-popup[data-v-63944a92]{padding:20px\n}\n.login-logo[data-v-63944a92]{text-align:center\n}\n.login-logo img[data-v-63944a92]{width:25%;margin:5% 0\n}\n.vlt-signup-divd p[data-v-63944a92]{display:block;margin:15px 0;color:#212121;font-weight:550;font-size:15px;text-align:center;font-family:\"ProximanovaBold\"\n}\n.vlt-signup-divd .orline[data-v-63944a92]{border-bottom:1px solid #dcdcdc;margin-top:5%\n}\n.social-logo[data-v-63944a92]{margin:0 10% 0 10%;display:-webkit-box;display:-ms-flexbox;display:flex\n}\n.social-logo div[data-v-63944a92]{-webkit-box-flex:1;-ms-flex:1;flex:1\n}\n.social-logo div div[data-v-63944a92]{cursor:pointer\n}\n.social-logo div div img[data-v-63944a92]{margin:10px;width:15%;float:left\n}\n.social-logo div div p[data-v-63944a92]{float:left;font-family:\"ProximanovaBold\";margin-left:5px\n}\n.social-fb div[data-v-63944a92]{background:#3b5998;border-radius:2px\n}\n.social-fb div p[data-v-63944a92]{color:#ffffff;font-size:18px;margin-top:10px\n}\n.social-google div[data-v-63944a92]{border:2px solid #efecec;border-radius:2px;background:#efecec\n}\n.social-google div p[data-v-63944a92]{color:#000000;font-size:18px;margin-top:8px\n}\n.login-form[data-v-63944a92]{margin:0 10% 0 10%\n}\n.vlt-input-group[data-v-63944a92]{margin:0 0 10px 0\n}\n.vlt-lgn-fgtpwd[data-v-63944a92]{color:#212121;font-family:\"ProximanovaBold\";margin-bottom:15px\n}\n.vlt-lgn-fgtpwd[data-v-63944a92]:hover{text-decoration:underline\n}\n.vlt-signup[data-v-63944a92]{padding:20px\n}\n.vlt-signup[data-v-63944a92] :nth-child(1){margin-left:15%\n}\n.vlt-signup[data-v-63944a92] :nth-child(2){margin-left:10px;cursor:pointer;font-weight:600\n}\n.vlt-signup p[data-v-63944a92]{color:#212121;float:left\n}\n.login-header[data-v-63944a92]{color:#212121;font-family:\"ProximanovaBold\";font-size:30px\n}\n.login-with[data-v-63944a92]{color:#212121;font-family:\"ProximanovaBold\";font-size:14px;text-align:justify;margin:2% 0\n}\n.or[data-v-63944a92]{color:#212121;font-family:\"ProximanovaRegular\";font-size:16px;font-weight:500;line-height:19px;text-align:justify\n}\n.login-label[data-v-63944a92]{color:#212121;font-family:\"ProximanovaBold\";font-size:16px;line-height:20px\n}\n.login-error-message[data-v-63944a92]{color:#d0021b;font-family:\"ProximanovaRegular\";font-size:16px;font-weight:100;line-height:18px;margin-top:5px\n}\n.new-user[data-v-63944a92]{color:#212121;font-family:\"ProximanovaRegular\";font-size:16px;line-height:18px\n}\n.signup[data-v-63944a92]{color:#4558dd !important;font-family:\"ProximanovaBold\";font-size:16px;line-height:18px;font-weight:bold;border:none;background:transparent\n}\n.signup[data-v-63944a92]:hover{text-decoration:underline\n}\n.check-container[data-v-63944a92]{margin:5%\n}\n.check-container p[data-v-63944a92]:first-child{text-align:center;font-size:15px;margin-bottom:10px;color:#212121;font-family:\"ProximanovaSemibold\"\n}\n.check-container button[data-v-63944a92]:nth-child(1){margin-bottom:20px\n}\n.check-container button.no[data-v-63944a92]{color:#212121 !important;background:#ffffff !important;border:1px solid #212121 !important\n}\n.check-container button.no[data-v-63944a92]:hover{background:#212121 !important;color:#ffffff !important\n}\n.agecheck[data-v-63944a92]{color:#212121;font-family:\"ProximanovaSemibold\";font-size:18px;line-height:30px\n}\n@media only screen and (max-width: 600px){\n.session-exp-popup[data-v-63944a92]{padding:10px\n}\n.vlt-input-group[data-v-63944a92]{margin:0 0 5px 0\n}\n.vlt-input-group label[data-v-63944a92]{font-size:14px\n}\n.login-header[data-v-63944a92]{font-size:20px\n}\n.vlt-signup-divd p[data-v-63944a92]{margin:7px 0;font-size:16px\n}\ninput[type=\"email\"][data-v-63944a92],input[type=\"password\"][data-v-63944a92],input[type=\"text\"][data-v-63944a92]{height:30px\n}\n.vlt-lgn-fgtpwd[data-v-63944a92]{margin-bottom:8px;font-size:12px\n}\nbutton[data-v-63944a92]{padding:8px;font-size:15px\n}\n.vlt-signup[data-v-63944a92]{padding:10px;text-align:center\n}\n.vlt-signup[data-v-63944a92] :nth-child(1){margin-left:0%\n}\n.vlt-signup[data-v-63944a92] :nth-child(2){margin-left:0%\n}\n.vlt-signup p[data-v-63944a92]{display:inline;text-align:center;float:none\n}\n.social-fb div p[data-v-63944a92]{font-size:14px\n}\n.social-google div p[data-v-63944a92]{font-size:14px\n}\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 377:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Popup',{attrs:{"width":_vm.width,"closePopupEvent":_vm.closePopupCB}},[_c('div',{attrs:{"slot":"header"},slot:"header"},[_c('h6',{staticClass:"login-header"},[_vm._v(_vm._s(_vm.showLoginForm ? "Already Have An Account" : _vm.emailPopup ? "Please Enter Your Email ID" : "Confirm Your 18+"))])]),_vm._v(" "),_c('div',{staticClass:"session-exp-popup"},[(_vm.showLoginForm)?_c('div',[_c('div',{staticClass:"login-logo"},[_c('img',{attrs:{"src":__webpack_require__(202),"alt":"logo"}})]),_vm._v(" "),_c('div',{staticStyle:{"margin-left":"10%"}},[_c('p',{staticClass:"login-with"},[_vm._v("Sign In With")])]),_vm._v(" "),_c('div',{staticClass:"social-logo"},[_c('div',{staticClass:"social-google"},[_c('div',{staticStyle:{"height":"100%","margin-right":"10px"},attrs:{"id":"googlelogin"}},[_c('img',{attrs:{"src":__webpack_require__(378),"alt":"google logo"}}),_vm._v(" "),_c('p',[_vm._v("Google")])])]),_vm._v(" "),_c('div',{staticClass:"social-fb"},[_c('div',{staticStyle:{"height":"100%"},attrs:{"id":"facebooklogin"},on:{"click":_vm.signupFacebookCB}},[_c('img',{attrs:{"src":__webpack_require__(379),"alt":"facebook logo"}}),_vm._v(" "),_c('p',[_vm._v("Facebook")])])])]),_vm._v(" "),_c('div',{staticClass:"vlt-signup-divd row"},[_c('div',{staticClass:"col-xs-5 col-sm-5 col-md-5 col-lg-5 col-xlg-5 orline"}),_vm._v(" "),_c('div',{staticClass:"col-xs-2 col-sm-2 col-md-2 col-lg-2 col-xlg-2"},[_c('p',{staticClass:"or"},[_vm._v("or")])]),_vm._v(" "),_c('div',{staticClass:"col-xs-5 col-sm-5 col-md-5 col-lg-5 col-xlg-5 orline"})]),_vm._v(" "),_c('div',{staticClass:"login-form"},[_c('form',{attrs:{"autocomplete":"off"},on:{"submit":function($event){$event.preventDefault();return _vm.loginUserCB($event)}}},[_c('input',{staticStyle:{"display":"none"},attrs:{"autocomplete":"false","name":"hidden","type":"text"}}),_vm._v(" "),_c('div',{staticClass:"vlt-lgn-form"},[_c('div',{staticClass:"vlt-input-group"},[_c('label',{staticClass:"login-label"},[_vm._v("Email")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.userEmail),expression:"userEmail"}],ref:"userEmail",attrs:{"id":"userEmail","type":"email","aria-label":"email","placeholder":"","maxlength":"128","tabindex":"1"},domProps:{"value":(_vm.userEmail)},on:{"input":function($event){if($event.target.composing){ return; }_vm.userEmail=$event.target.value}}}),_vm._v(" "),_c('p',{staticClass:"login-error-message"},[_vm._v(_vm._s(_vm.userEmailError))])]),_vm._v(" "),_c('div',{staticClass:"vlt-input-group input-ico"},[_c('label',{staticClass:"login-label"},[_vm._v("Password")]),_vm._v(" "),_c('div',{staticClass:"vlt-input"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.password),expression:"password"}],attrs:{"id":"password","type":"password","aria-label":"password","placeholder":"","autocomplete":"off","maxlength":"16","tabindex":"2"},domProps:{"value":(_vm.password)},on:{"input":function($event){if($event.target.composing){ return; }_vm.password=$event.target.value}}}),_vm._v(" "),_c('p',{staticClass:"login-error-message"},[_vm._v(_vm._s(_vm.passwordError))]),_vm._v(" "),_c('span',{staticClass:"ico-img",staticStyle:{"cursor":"pointer"}},[_c('img',{attrs:{"src":_vm.iconEyeOpenPath,"alt":"eye img"},on:{"click":_vm.toggleInputMode}})])])]),_vm._v(" "),_c('p',{staticClass:"vlt-link vlt-lgn-fgtpwd",on:{"click":function () { return _vm.showResetPasswordPopup(true); }}},[_vm._v("Forgot Password?")]),_vm._v(" "),_c('div',{staticClass:"vlt-lgn-btns"},[_c('button',{ref:"loginBtnSubmit",staticClass:"btn-lg-primary",attrs:{"type":"submit","aria-label":"Sign In"}},[_vm._v("Sign In")])])])])]),_vm._v(" "),_c('Loading',{directives:[{name:"show",rawName:"v-show",value:(_vm.showLoading),expression:"showLoading"}]}),_vm._v(" "),_c('div',{staticClass:"vlt-signup"},[_c('p',{staticClass:"new-user"},[_vm._v("Don't have an Account?")]),_vm._v(" "),_c('button',{ref:"signupBtn",staticClass:"signup",attrs:{"aria-label":"Sign Up"},on:{"click":_vm.openSignUpPopup}},[_vm._v("Sign up")])])],1):_vm._e(),_vm._v(" "),(!_vm.showLoginForm)?_c('div',{staticClass:"check-container"},[(_vm.emailPopup)?_c('div',[_c('p',[_vm._v("We are unable to get your Email ID, Please enter your Email ID to proceed.")]),_vm._v(" "),_c('div',{staticClass:"vlt-lgn-btns"},[_c('div',{staticClass:"vlt-input-group"},[_c('label',{staticClass:"login-label"},[_vm._v("Email ID")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.userEmail),expression:"userEmail"}],ref:"fbUserEmail",attrs:{"id":"userEmail","type":"email","aria-label":"email","placeholder":"","maxlength":"128","tabindex":"1"},domProps:{"value":(_vm.userEmail)},on:{"input":function($event){if($event.target.composing){ return; }_vm.userEmail=$event.target.value}}}),_vm._v(" "),_c('p',{staticClass:"login-error-message"},[_vm._v(_vm._s(_vm.userEmailError))])]),_vm._v(" "),_c('div',{staticClass:"movie-filter",staticStyle:{"margin-top":"15px"}},[_c('label',{staticClass:"checkboxcontainer agecheck",attrs:{"for":"ageCheck"}},[_vm._v("\n              I'm 18+\n              "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.ageCheck),expression:"ageCheck"}],attrs:{"type":"checkbox","name":"checkbox","value":"1","id":"ageCheck"},domProps:{"checked":Array.isArray(_vm.ageCheck)?_vm._i(_vm.ageCheck,"1")>-1:(_vm.ageCheck)},on:{"change":function($event){var $$a=_vm.ageCheck,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v="1",$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.ageCheck=$$a.concat([$$v]))}else{$$i>-1&&(_vm.ageCheck=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.ageCheck=$$c}}}}),_vm._v(" "),_c('span',{staticClass:"checkmark"})])]),_vm._v(" "),_c('button',{ref:"loginBtnSubmit",staticClass:"btn-lg-primary",attrs:{"type":"button","aria-label":"Yes"},on:{"click":_vm.proceedClick}},[_vm._v("Proceed")])])]):_c('div',[_c('p',[_vm._v("You must be 18+ to Create an SDG Account")]),_vm._v(" "),_c('button',{ref:"loginBtnSubmit",staticClass:"btn-lg-primary",staticStyle:{"margin-bottom":"10px"},attrs:{"type":"button","aria-label":"Yes"},on:{"click":function($event){return _vm.check18plus(1)}}},[_vm._v("yes, i'm 18+")]),_vm._v(" "),_c('button',{ref:"loginBtnSubmit",staticClass:"btn-lg-primary no",attrs:{"type":"button","aria-label":"No"},on:{"click":function($event){return _vm.check18plus(0)}}},[_vm._v("no, i'm not")])])]):_vm._e(),_vm._v(" "),_c('FormError',{directives:[{name:"show",rawName:"v-show",value:(_vm.formError),expression:"formError"}],attrs:{"message":_vm.formError}})],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 378:
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),

/***/ 379:
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIiB2ZXJzaW9uPSIxLjEiIGlkPSJMYXllcl8xIiB4PSIwcHgiIHk9IjBweCIgdmlld0JveD0iMCAwIDMxMCAzMTAiIHN0eWxlPSJlbmFibGUtYmFja2dyb3VuZDpuZXcgMCAwIDMxMCAzMTA7IiB4bWw6c3BhY2U9InByZXNlcnZlIj4KPGcgaWQ9IlhNTElEXzgzNF8iPgoJPHBhdGggaWQ9IlhNTElEXzgzNV8iIGQ9Ik04MS43MDMsMTY1LjEwNmgzMy45ODFWMzA1YzAsMi43NjIsMi4yMzgsNSw1LDVoNTcuNjE2YzIuNzYyLDAsNS0yLjIzOCw1LTVWMTY1Ljc2NWgzOS4wNjQgICBjMi41NCwwLDQuNjc3LTEuOTA2LDQuOTY3LTQuNDI5bDUuOTMzLTUxLjUwMmMwLjE2My0xLjQxNy0wLjI4Ni0yLjgzNi0xLjIzNC0zLjg5OWMtMC45NDktMS4wNjQtMi4zMDctMS42NzMtMy43MzItMS42NzNoLTQ0Ljk5NiAgIFY3MS45NzhjMC05LjczMiw1LjI0LTE0LjY2NywxNS41NzYtMTQuNjY3YzEuNDczLDAsMjkuNDIsMCwyOS40MiwwYzIuNzYyLDAsNS0yLjIzOSw1LTVWNS4wMzdjMC0yLjc2Mi0yLjIzOC01LTUtNWgtNDAuNTQ1ICAgQzE4Ny40NjcsMC4wMjMsMTg2LjgzMiwwLDE4NS44OTYsMGMtNy4wMzUsMC0zMS40ODgsMS4zODEtNTAuODA0LDE5LjE1MWMtMjEuNDAyLDE5LjY5Mi0xOC40MjcsNDMuMjctMTcuNzE2LDQ3LjM1OHYzNy43NTJIODEuNzAzICAgYy0yLjc2MiwwLTUsMi4yMzgtNSw1djUwLjg0NEM3Ni43MDMsMTYyLjg2Nyw3OC45NDEsMTY1LjEwNiw4MS43MDMsMTY1LjEwNnoiIHN0eWxlPSJmaWxsOiByZ2IoMjU1LCAyNTUsIDI1NSk7Ij48L3BhdGg+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPC9zdmc+Cg=="

/***/ })

});


// WEBPACK FOOTER //
// static/js/35.0dc7b051f4664b7f47ec.js